"use client";

function formatCompactCountBase(value: number): string {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n) || n < 0) return "0";

  if (n >= 1_000_000) {
    const millions = n / 1_000_000;
    const decimals = millions < 10 && n % 1_000_000 !== 0 ? 1 : 0;
    return `${millions.toFixed(decimals).replace(/\.0$/, "")}M`;
  }

  if (n >= 1_000) {
    const thousands = n / 1_000;
    if (thousands >= 999.95) {
      const millions = n / 1_000_000;
      return `${millions.toFixed(1).replace(/\.0$/, "")}M`;
    }
    const decimals = (thousands < 10 || thousands >= 100) && n % 1_000 !== 0 ? 1 : 0;
    return `${thousands.toFixed(decimals).replace(/\.0$/, "")}K`;
  }

  return String(n);
}

/**
 * Whole-profile counts from the API; round first so float totals never format
 * as 1000.0K instead of 1M. Pass `estimate` true when the count is a capped
 * lower bound (the backend tracks hits only up to a cap on the live path, then
 * fills the exact total async) — renders e.g. "10K+".
 */
export function formatCompactCount(value: number, estimate = false): string {
  const base = formatCompactCountBase(value);
  return estimate ? `${base}+` : base;
}
